import { Component} from '@angular/core';
import { NavbarComponent } from '../navbar/navbar.component';
import { HeaderComponent } from '../header/header.component';
import { PackageOfServicesComponent } from '../package-of-services/package-of-services.component';
import { ContactsComponent } from '../contacts/contacts.component';
import { TermsComponent } from '../terms/terms.component';
import { FooterComponent } from '../footer/footer.component';
import { ReviewComponent } from '../review/review.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ModalComponent } from '../modal/modal.component';
import { PaymentComponent } from '../payment/payment.component';
import { SignInstructionComponent } from "../sign-instruction/sign-instruction.component";
import { FaqComponent } from "../faq/faq.component";

@Component({
  selector: 'app-landing', 
  standalone: true,
  imports: [
    NavbarComponent,
    HeaderComponent,
    PackageOfServicesComponent,
    ContactsComponent,
    TermsComponent,
    ReviewComponent,
    FooterComponent,
    ModalComponent,
    PaymentComponent,
    TranslateModule,
    MatDialogModule,
    SignInstructionComponent,
    FaqComponent
],
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
})
export class LandingComponent {
  sentMessage: string;  

  receiveMessage(message: string) {  
    this.sentMessage = message;  
  }  
}
